import { get, isNil } from 'lodash';
import { getPackagesMap } from '@adjust/dashboard-core/lib/utils/account';
import userFeatures from '@adjust/dashboard-core/lib/constants/userFeatures';

// Checks if feature is available for a particular account
export function featureIsAvailable(account, packages, { key, required_package }) {
  return required_package ? !!packages[required_package] : get(account, `features.${key}.enabled`, false);
}

// Gets a list of the disabled features for a user
const getDisabledFeatures = user => {
  const featuresList = ['ad_revenue', 'revenue_data', 'cost_data'];
  // NOTE: if we don't find features listed in `featuresList`, we consider they are disabled.
  const disabledFeatures = featuresList.filter(
    featureName =>
      !user.local_roles?.features?.some(userPermissionFeature => userPermissionFeature.name === featureName),
  );

  const featuresWithRoleNone =
    user.local_roles?.features?.filter(feature => feature.role === 'none').map(feature => feature.name) || [];
  return disabledFeatures.concat(featuresWithRoleNone);
};
export function isNewUser(user) {
  return isNil(user?.created_at);
}

const isFeatureConfigured = (user, feature) =>
  user.local_roles.features.some(featurePermission => featurePermission.name === feature.key);

// Checks if feature is enabled for a particular user
export function featureIsEnabled(user, featureKey) {
  const disabledFeatures = getDisabledFeatures(user);
  return !disabledFeatures.includes(featureKey);
}

// Gets features for the user management
export const getFeaturesForForm = (user, account) => {
  const packages = getPackagesMap(account);

  return userFeatures.flatMap(feature => {
    if (featureIsAvailable(account, packages, feature)) {
      const enabled =
        isNewUser(user) && !isFeatureConfigured(user, feature) ? feature.enabled : featureIsEnabled(user, feature.key);

      return {
        ...feature,
        available: true,
        enabled,
      };
    }

    return [];
  });
};
